import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Banner from '@src/pc/components/Banner';
import Nav from '@src/pc/components/Nav';
import Footer from '@src/pc/components/Footer';
import ModuleHead from '@src/pc/components/ModuleHead';
import PicText from '@src/pc/components/PicText';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';

const Layout = ({ content }) => {
    return (
        <div className={styles.layout}>
            <Banner content={content.banner} />
            <Nav content={content.nav} activeIndex={1} />
            <div className={styles.space21} />
            <div className={styles.col_1000}>
                <Chip id="260460" type="struct" title="历届峰会头" groupName="历届峰会" content={content.historyHead}>
                    <ModuleHead />
                </Chip>
                <Chip id="287311" type="recommend" title="历届峰会内容" groupName="历届峰会">
                    <div>
                        {content.historyContent.map((item, index) => {
                            return <PicText content={item} key={index} />;
                        })}
                    </div>
                </Chip>
            </div>
            <div className={styles.space50} />
            <Footer content={content.footer} />
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
